// extracted by mini-css-extract-plugin
export default {"payment_header":"Payment_payment_header__wvECs","payment_container":"Payment_payment_container__uLSoH","flex":"Payment_flex__6Q2TA","loading":"Payment_loading__sSV9n"};